import styled, { css } from 'styled-components';
import { CTAIconStyle } from 'components/content/ContentSidebar/common/style';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
import { ArrowLeftIcon, ArrowRightIcon, Plus } from 'theme/icons';
import { THUMBNAIL_SIZE } from '../constants';
var TRASH_ICON_CONTAINER_SIZE = '40px';
var ARROW_ICON_SIZE = '24px';
var iconStyle = css(["width:", ";height:", ";", " cursor:pointer;&:hover path{fill:", ";}"], ARROW_ICON_SIZE, ARROW_ICON_SIZE, CTAIconStyle, colorUsage.iconGradientHoverForeground);
var RightArrow = styled(ArrowRightIcon).withConfig({
  displayName: "Carouselstyle__RightArrow",
  componentId: "sc-1our7f0-0"
})(["", ""], iconStyle);
var LeftArrow = styled(ArrowLeftIcon).withConfig({
  displayName: "Carouselstyle__LeftArrow",
  componentId: "sc-1our7f0-1"
})(["", ""], iconStyle);
var CarouselContent = styled.div.withConfig({
  displayName: "Carouselstyle__CarouselContent",
  componentId: "sc-1our7f0-2"
})(["flex-grow:1;min-width:0;"]);
var Container = styled.div.withConfig({
  displayName: "Carouselstyle__Container",
  componentId: "sc-1our7f0-3"
})(["display:flex;align-items:center;"]);
var SlideContainer = styled.div.withConfig({
  displayName: "Carouselstyle__SlideContainer",
  componentId: "sc-1our7f0-4"
})(["position:relative;display:", ";margin-top:", ";padding:", ";border:1px solid ", ";border-radius:", ";"], function (_ref) {
  var display = _ref.display;
  return display;
}, getSpacing(3), getSpacing(3), colorUsage.filtersBarBorder, borderRadius.large); // TODO: Design for garbage icon

var RemoveField = styled.div.withConfig({
  displayName: "Carouselstyle__RemoveField",
  componentId: "sc-1our7f0-5"
})(["position:absolute;top:", ";right:", ";display:flex;align-items:center;justify-content:center;width:", ";height:", ";border:1px solid ", ";border-radius:50%;cursor:pointer;"], getSpacing(3), getSpacing(3), TRASH_ICON_CONTAINER_SIZE, TRASH_ICON_CONTAINER_SIZE, colorUsage.carousel.remove.border);
var IconContainer = styled.div.withConfig({
  displayName: "Carouselstyle__IconContainer",
  componentId: "sc-1our7f0-6"
})(["display:inline-flex;padding:0 ", ";visibility:", ";"], getSpacing(2), function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'visible' : 'hidden';
});
var ThumbnailsContainer = styled.div.withConfig({
  displayName: "Carouselstyle__ThumbnailsContainer",
  componentId: "sc-1our7f0-7"
})(["display:flex;justify-content:space-between;"]);
var Insert = styled.div.withConfig({
  displayName: "Carouselstyle__Insert",
  componentId: "sc-1our7f0-8"
})(["display:flex;align-items:center;justify-content:center;min-width:", ";height:", ";border:1px dashed ", ";border-radius:", ";cursor:pointer;"], THUMBNAIL_SIZE, THUMBNAIL_SIZE, colorUsage.carousel.append, borderRadius.medium);
var PlusIcon = styled(Plus).withConfig({
  displayName: "Carouselstyle__PlusIcon",
  componentId: "sc-1our7f0-9"
})(["& path{fill:", ";}"], colorUsage.carousel.append);
export { Insert, SlideContainer, Container, RightArrow, LeftArrow, PlusIcon, RemoveField, IconContainer, CarouselContent, ThumbnailsContainer };